<div class="flex flex-col items-start gap-4 py-4 md:border-bottom bg-white">
    <div class="flex w-full justify-between items-center">
        <h2 class="text-xl text-black font-bold">امکانات {{ pdpUiService.hotelFullName }}</h2>
        <button mat-button color="primary" class="icon-arrow-button !hidden md:!flex" (click)="openModal()">
            <span class="text-blue-500 text-sm !font-medium">مشاهده همه امکانات</span>
            <i class="ico-Left !text-2xl text-blue-500"></i>
      </button>
    </div>

    <div *ngIf="_dataSource" class="grid grid-cols-2 md:grid-cols-4 gap-4 w-full">
        <div class="flex items-center gap-2 whitespace-nowrap" *ngFor="let item of _dataSource[0]?.HotelFacilities">

            <i class="text-2xl text-muted {{ replace(item.IconClassName) }}"></i>
            <span class="text-muted text-sm">{{ item.Name }}</span>
            <span *ngIf="item.AskFree && !item.IsFree"
                class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                شامل هزینه
            </span>

            <span *ngIf="!item.AskFree && item.IsFree"
                class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                رایگان
            </span>
        </div>
        <ng-container *ngIf="facilityLength < 8">
            <div class="flex items-center gap-2 whitespace-nowrap" *ngFor="let item of alternativeFacilities">
                <ng-container
                    *ngIf="!item.IconClassName.includes('ico-Parking') && !item.IconClassName.includes('ico-Wifi') ">

                    <i class="text-2xl text-muted {{ replace(item.IconClassName) }}"></i>
                    <span class="text-muted text-sm">{{ item.Name }}</span>
                    <span *ngIf="item.AskFree && !item.IsFree"
                        class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                        شامل هزینه
                    </span>

                    <span *ngIf="!item.AskFree && item.IsFree"
                        class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                        رایگان
                    </span>
                </ng-container>

                <ng-container *ngIf="item.InternetClassName || item.ParkingClassName">
                    <i class="text-2xl text-muted {{ replace(item.IconClassName) }}"></i>
                    <span class="text-muted text-sm">{{ item.Name }}</span>
                    <span *ngIf="item.InternetClassName?.includes('with-money','limited')"
                        class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                        شامل هزینه
                    </span>
                    <span *ngIf="item.ParkingClassName?.includes('with-money','limited')"
                        class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                        شامل هزینه
                    </span>

                    <span *ngIf="item.InternetClassName === 'has-not'"
                        class="bg-gray-200 mx-1 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                        ندارد
                    </span>
                    <span *ngIf="item.ParkingClassName === 'has-not'"
                        class="bg-gray-200 mx-1 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                        ندارد
                    </span>

                    <span *ngIf="item.ParkingClassName === 'free'"
                        class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                        رایگان

                    </span>
                    <span *ngIf="item.InternetClassName === 'free'"
                        class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                        رایگان

                    </span>

                </ng-container>
            </div>
        </ng-container>
    </div>

    <button mat-button color="primary" class="icon-arrow-button md:!hidden" (click)="openModal()">
        <span>مشاهده همه امکانات</span>
        <i class="ico-Left !text-2xl text-blue-500"></i>
    </button>
</div>


<div class="hidden-custom">
    <div class="grid grid-cols-2 gap-2">
        <div class="" *ngFor="let item of alternativeFacilities">

            <div class="flex items-center gap-4">
                <ng-container
                    *ngIf="!item.IconClassName.includes('ico-Parking') && !item.IconClassName.includes('ico-Wifi') ">

                    <i class="text-2xl text-muted {{ replace(item.IconClassName) }}"></i>
                    <span class="text-muted text-sm">{{ item.Name }}</span>
                    <span *ngIf="item.AskFree && !item.IsFree"
                        class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                        شامل هزینه
                    </span>
                    <span *ngIf="!item.AskFree && item.IsFree"
                        class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                        رایگان
                    </span>

                </ng-container>

                <ng-container *ngIf="item.InternetClassName || item.ParkingClassName">
                    <div class="flex flex-col">
                        <div class="flex items-center">
                            <i class="text-2xl text-muted {{ replace(item.IconClassName) }}"></i>
                            <span class="text-muted text-sm mx-2">{{ item.Name }}</span>
                            <span *ngIf="item.InternetClassName?.includes('with-money','limited')"
                                class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                شامل هزینه
                            </span>
                            <span *ngIf="item.ParkingClassName?.includes('with-money','limited')"
                                class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                شامل هزینه
                            </span>

                            <span *ngIf="item.InternetClassName == 'has-not'"
                                class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                ندارد
                            </span>
                            <span *ngIf="item.ParkingClassName == 'has-not'"
                                class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                ندارد
                            </span>

                            <span *ngIf="item.ParkingClassName == 'free'"
                                class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                رایگان

                            </span>
                            <span *ngIf="item.InternetClassName == 'free'"
                                class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                رایگان

                            </span>
                        </div>

                        <p *ngIf="item.Description" class="text-sm text-black-300 mt-3">{{item.Description}}</p>
                    </div>

                </ng-container>
            </div>
        </div>
    </div>
    <ng-container *ngIf="travelHealth">
        <h4 class="my-4">{{travelHealth.Title}}</h4>

        <div class="grid grid-cols-2 gap-2">
            <div *ngFor="let item of travelHealth.HotelFacilities" class="flex items-top gap-2 text-black-300">
                <i class="text-xl {{replace(item.IconClassName)}}"></i>
                <div class="flex flex-col">
                    <h5 class="text-black-300 text-sm">{{item.Name}}</h5>
                    <p class="text-sm">{{item.Description}}</p>

                </div>
            </div>
        </div>
    </ng-container>

    <div *ngIf="_dataSource && _dataSource?.length">

        <ng-container *ngFor="let item of _dataSource">
            <h4 class="my-4">{{item.Name}}</h4>

            <div class="grid grid-cols-2 gap-2">
                <ng-container *ngFor="let facility of item.HotelFacilities">
                    <div class="flex items-center gap-2 text-black-300"
                        *ngIf="!facility.IconClassName.includes('ico-Parking')">

                        <i [ngClass]="replace(facility.IconClassName)" class="text-xl"></i>
                        <h5 class="text-sm">{{facility.Name}}</h5>
                        <span *ngIf="facility.AskFree && !facility.IsFree"
                            class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                            شامل هزینه
                        </span>
                        <span *ngIf="!facility.AskFree && facility.IsFree"
                            class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                            رایگان
                        </span>

                    </div>

                </ng-container>
            </div>
        </ng-container>


    </div>
</div>



